import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface SelectOpen {
    isOpen: boolean;
}
const initialState: SelectOpen = {
    isOpen: false,
};
const SelectOpenSlice = createSlice({
    name: 'SelectOpen',
    initialState,
    reducers: {
        setSelectOpen: (state, action: PayloadAction<boolean>) => {
            state.isOpen = action.payload;
        },
    },
});

export const { setSelectOpen } = SelectOpenSlice.actions;
export default SelectOpenSlice.reducer;
